import Badge from "./Badge";

const VerifiedBadge = ({ isVerified }) => {
  const color = isVerified ? "success" : "danger";

  return <Badge color={color} className="me-1">{isVerified ? "تایید شده" : "تایید نشده"}</Badge>;
};

export default VerifiedBadge;
